let View = require('views/view')
let app = require('application')

module.exports = View.extend({
  template: require('views/templates/cart/cart'),
  events () { // On récupère ici les events de view (les event globaux) pis on ajoute les spécifiques a cette vue (SOURCE : http://stackoverflow.com/questions/9403675/backbone-view-inherit-and-extend-events-from-parent)
    return _.extend({}, View.prototype.events, {
      'click .btn-remove-cart': 'removeFromCart'
    })
  },
  list () {
    $('#cart-list').html('<i class="fa fa-refresh fa-spin"></i> Chargement en cours...')
    this.refreshList()
  },
  refreshList () {
    let cart = {}
    if (localStorage) {
      cart = JSON.parse(localStorage.getItem('cart'))
    }
    let data = { products: cart.products }

    app.ajax({
      url: '/cart/recap',
      type: 'POST',
      dataType: 'json',
      data,
      complete: app.onComplete({
        complete: (cart) => {
          $('#cart-list').html(require('views/templates/cart/recap')({
            cart
          })).show()
          if (cart.length) {
            this.initPaypalButtons()
            this.calculTotal()
          }
        }
      })
    })
  },
  calculTotal (e) {
    let total = 0
    // let prices = $('#cart-recap-content td.prix')
    $('#cart-recap-content td.prix').each(function () {
      if ($(this).data('value')) total += parseFloat($(this).data('value'))
    })

    $('#cart-recap-content td.total').data('amount', total).html('<h3><strong>' + Handlebars.euros(total) + '</strong></h3>')
  },
  removeFromCart (e) {
    if (e) e.preventDefault()
    let id = $(e.currentTarget).data('id')

    if (localStorage && localStorage.getItem('cart')) {
      let oldCart = JSON.parse(localStorage.getItem('cart'))
      let cart = {}
      cart.products = oldCart.products.filter((obj) => obj.id_conseil !== id)

      localStorage.setItem('cart', JSON.stringify(cart))
      this.list()
    }
  },
  initPaypalButtons () {
    paypal.Button.render({
      env: 'sandbox', // 'sandbox' || 'production'
      locale: 'fr_FR',
      style: {
        color: 'blue',
        fundingicons: true,
        size: 'responsive',
        label: 'checkout'
      },
      client: {
        sandbox: 'ARfeA4vP337rxyn1t1ZekJWdpiuD00aOTTljjOQ8nhoxpbov5NepzA0xrQdreHNmfFW9nyqvciIzGEYP',
        production: 'xxxxxxxxx'
      },
      commit: true,
      payment: function (data, actions) {
        /*
         * Set up the payment here
         */
        let amount = $('#cart-recap-content td.total').data('amount')
        if (!amount) {
          console.warn('No amount found')
          return false
        }
        return actions.payment.create({
          payment: {
            transactions: [
              {
                amount: { total: amount, currency: 'EUR' }
              }
            ]
          }
        })
      },

      onAuthorize: function (data, actions) {
        /*
         * Execute the payment here
         */
        return actions.payment.execute().then(function (payment) {
          // The payment is complete!
          // You can now show a confirmation message to the customer
          alert('Payment DONE !', payment)
          $('#error-box').hide()
          $('#success-box').html('<i class="fa fa-spin fa-spinner></i> Veuillez patientez, nous finalisons votre commande').fadeIn()
          let cart = app.getCart()
          app.ajax({
            url: '/commande',
            type: 'POST',
            data: { cart, payment },
            complete: app.onComplete({
              success: (id) => {
                let txt = 'Commande terminée ! <br>'
                txt += 'Vous pouvez consulter votre commande en cliquant '
                txt += '<a href="/#!commande/' + id + '">ICI</a><br>'
                txt += 'Ou vous pouvez aller voir dans vos conseils vos achats en cliquant '
                txt += '<a href="/#!conseil">ICI</a><br><br>'
                txt += 'Merci de votre achat'
                $('#success-box').html(txt).show()
                $('#cart-recap-content').hide()
              }
            })
          })
        })
      },

      onCancel: function (data, actions) {
        /*
         * Buyer cancelled the payment
         */
        console.log('onCancel !', data, actions)
        $('#success-box').hide()
        $('#error-box').html('Action annulée.').fadeIn()
      },

      onError: function (err) {
        /*
         * An error occurred during the transaction
         */
        console.log('onError !', err)
        $('#success-box').hide()
        $('#error-box').html('Erreur lors du paiement, veuillez recommencer').fadeIn()
      }
    }, '#paypal-button')
  }

})
